var render = function render(){var _vm=this,_c=_vm._self._c;return (['accepted', 'scheduled'].includes(_vm.booking.status))?_c('div',{staticClass:"space-y-6"},[_c('div',{staticClass:"grid grid-cols-1 gap-5"},[_c('CancelBookingAction',{staticClass:"text-red-600"})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }